import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../components/common/PageTitle';
import { CenteredLayout } from '../../components/layouts';
import AdminNavbar from '../../components/layouts/AdminNavbar';
import { userRoleEnum } from '../../utils/enums';
import UserContext from '../AppRouter/UserContext';
import useExpectedHours from '../../hooks/useExpectedHours';
import ExpectedHoursList from '../../components/layouts/ExpectedHoursList';
import { getDefaultSettlementPeriod } from '../../utils/consts';
import type { IHoursCheckerFilters } from '../../hooks/useExpectedHours';

const HoursChecker: React.FC = () => {
  const [{ month: selectedMonth, year: selectedYear }, setSettlementSelection] = useState(
    getDefaultSettlementPeriod
  );

  const setSelectedMonth = (month: string) =>
    setSettlementSelection((prev) => ({ ...prev, month }));
  const setSelectedYear = (year: number) =>
    setSettlementSelection((prev) => ({ ...prev, year }));

  const [filters, setFilters] = useState<IHoursCheckerFilters>({});

  const {
    expectedHours,
    getExpectedHours,
    isLoading,
    acceptSettlement,
    rejectSettlement
  } = useExpectedHours(selectedMonth, selectedYear, filters);
  const { userData } = useContext(UserContext);
  const location = useLocation();
  const previousRouteKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const routeKey = `${location.pathname}${location.hash}`;
    const onHoursChecker =
      location.pathname.includes("hours-checker") ||
      location.hash.includes("hours-checker");
    const prev = previousRouteKeyRef.current;
    previousRouteKeyRef.current = routeKey;
    if (prev !== null && prev !== routeKey && onHoursChecker) {
      getExpectedHours();
    }
  }, [location.pathname, location.hash, getExpectedHours]);

  return (
    <>
      {userData.data.baseRole === userRoleEnum.Admin && <AdminNavbar />}
      <CenteredLayout>
        <PageTitle title="Rozliczenie godzin usług" />
        <div className="table-container">
          <ExpectedHoursList
            isLoading={isLoading}
            getMoreItems={getExpectedHours}
            items={expectedHours}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
            acceptSettlement={acceptSettlement}
            rejectSettlement={rejectSettlement}
            filters={filters}
            setFilters={setFilters}
          />
        </div>
      </CenteredLayout>
    </>
  );
};

export default HoursChecker;
